import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Button as BaseButton } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import ProductsForm from '@app/components/apps/Products/ProductsForm';
import { useLocation } from 'react-router-dom';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

export const ViewProductPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Product');

  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/products',
      breadcrumbName: 'Products',
    },
    {
      path: '/view-product',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ProductsForm
          type={'view'}
          editable={false}
          id={id}
          pageTitle={`View Product`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default ViewProductPage;
